/* eslint-disable @typescript-eslint/no-unused-vars */
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";

import { benefits } from "./data";
import { StyledDescription } from "./styles";

interface TopPresentationProps {
  onContactClick: () => void;
}

export default function TopPresentation({
  onContactClick,
}: TopPresentationProps) {
  const handleSearch = (searchTerm: string) => {
    console.log("Busca por:", searchTerm);
  };

  return (
    <section>
      <Box
        sx={{
          background:
            "linear-gradient(to bottom right, #17579E, #337AB7, #4F8DCB)",
          color: "white",
          py: 10,
          "@media (max-width:480px)": {
            py: 4,
          },
        }}
      >
        <Container maxWidth="lg">
          <Box
            textAlign="center"
            mb={6}
            sx={{
              "@media (max-width:480px)": {
                mb: 3,
              },
            }}
          >
            <Typography
              variant="h2"
              component="h1"
              fontWeight="bold"
              gutterBottom
              sx={{
                 fontSize: "3.2rem",
                "@media (max-width:480px)": {
                  fontSize: "1.8rem",
                },
              }}
            >
              Sistemas Flex
            </Typography>

            <Typography
              variant="h4"
              component="h2"
              fontWeight="normal"
              color="rgba(191, 219, 254, 1)"
              display="block"
              mb={2}
              sx={{
                "& .mobile-br": { display: "none" },
                fontSize: "2.4rem",
                "@media (max-width:480px)": {
                  fontSize: "1.4rem",
                  "& .mobile-br": { display: "block" },
                },
              }}
            >
              {"Sites que vendem do design à entrega"}
              <br className="" />
            </Typography>

            <StyledDescription>
              Criamos sites, lojas virtuais e sistemas web profissionais para
              impulsionar seu negócio digital. Soluções completas com design
              moderno e tecnologia de ponta.
            </StyledDescription>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              justifyContent="center"
              mb={6}
              sx={{
                "@media (max-width:480px)": {
                  mb: 4,
                },
              }}
            >
              <Button
                onClick={onContactClick}
                variant="contained"
                startIcon={<WhatsAppIcon />}
                sx={{
                  backgroundColor: "white",
                  color: "primary.main",
                  fontWeight: "bold",
                  px: 4,
                  py: 1.5,
                  borderRadius: "50px",
                  transition: "0.5s",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.9)",
                    transform: "scale(1.05)",
                    transition: "0.5s",
                  },
                  "@media (max-width:599px)": {
                    maxWidth: "230px",
                    width: "100%",
                    alignSelf: "center",
                  },
                  "@media (max-width:480px)": {
                    fontSize: "14px",
                    py: 1.3,
                  },
                }}
              >
                Fale conosco
              </Button>

              <Button
                component={RouterLink}
                to="/agendar"
                variant="outlined"
                startIcon={<CalendarMonthIcon />}
                sx={{
                  borderColor: "rgba(255, 255, 255, 0.7)",
                  color: "white",
                  fontWeight: "bold",
                  px: 4,
                  py: 1.5,
                  borderRadius: "50px",
                  transition: "0.5s",
                  "&:hover": {
                    borderColor: "white",
                    backgroundColor: "rgba(255, 255, 255, 0.12)",
                    transform: "scale(1.05)",
                    transition: "0.5s",
                  },
                  "@media (max-width:599px)": {
                    maxWidth: "230px",
                    width: "100%",
                    alignSelf: "center",
                  },
                  "@media (max-width:480px)": {
                    fontSize: "14px",
                    py: 1.3,
                  },
                }}
              >
                Agendar reunião
              </Button>
            </Stack>
          </Box>

          <Grid container spacing={{ xs: 2, md: 4 }} justifyContent="center">
            {benefits.map((item, idx) => (
              <Grid item xs={12} md={4} key={idx}>
                <Box textAlign="center">
                  <Paper
                    elevation={0}
                    sx={{
                      bgcolor: "rgba(255, 255, 255, 0.2)",
                      borderRadius: "50%",
                      width: 64,
                      height: 64,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mx: "auto",
                      mb: 2,
                      "@media (max-width:480px)": {
                        width: 54,
                        height: 54,
                      },
                    }}
                  >
                    {item.icon}
                  </Paper>
                  <Typography
                    variant="h6"
                    component="h4"
                    fontWeight="bold"
                    mb={1}
                    sx={{
                      "@media (max-width:480px)": {
                        fontSize: "17px",
                        mb: 0.5,
                      },
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="rgba(191, 219, 254, 1)"
                    sx={{
                      "@media (max-width:480px)": {
                        fontSize: "15px",
                        lineHeight: 1.3,
                      },
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </section>
  );
}
